import { GraviButton, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import { useEbolMatchingContext } from '../../EbolMatchingContext'
import { useOrderMovements } from '@api/useOrderMovements'
import { useCallback } from 'react'
import { useDrawerType } from '../../Hooks/useDrawerType'

const CloseBtn = () => {
  const { close } = useEbolMatchingContext()
  return <GraviButton buttonText='Cancel' onClick={close} appearance='text' />
}

const MatchBtn = () => {
  const { selectedBolId, selectedOrderId, selectedEbolId, close } = useEbolMatchingContext()
  const { useMatchBolMutation } = useOrderMovements()
  const { mutateAsync, isPending } = useMatchBolMutation(selectedOrderId ?? '')
  const disabled = !selectedEbolId || !selectedBolId || !selectedOrderId || isPending
  const match = useCallback(() => {
    if (disabled) return
    mutateAsync({ body: { bol_id: selectedBolId, ebol_id: selectedEbolId } }).then(() => close())
  }, [selectedEbolId, selectedBolId, close, mutateAsync, disabled])

  return <GraviButton buttonText='Match' disabled={disabled} loading={isPending} onClick={match} color='primary' />
}

const UnmatchBtn = () => {
  const { selectedOrderId, selectedBolId, close } = useEbolMatchingContext()
  const { useUnmatchBolMutation } = useOrderMovements()
  const { mutateAsync, isPending: isUnmatching } = useUnmatchBolMutation(selectedOrderId ?? '')
  const disabled = isUnmatching || !selectedOrderId || !selectedBolId
  const unmatch = useCallback(() => {
    if (disabled) return
    mutateAsync({ params: { query: { bol_id: selectedBolId } } }).then(() => close())
  }, [mutateAsync, selectedBolId, disabled, close])
  return (
    <GraviButton buttonText='Unmatch' disabled={disabled} loading={isUnmatching} onClick={unmatch} color='primary' />
  )
}

const InfoText = () => {
  return (
    <>
      <MaterialIcon icon='info' size={20} />
      <Texto style={{ flex: 1, flexGrow: 1, paddingRight: '100px', paddingLeft: '20px', fontStyle: 'italic' }}>
        Multiple products, terminals, or suppliers can be mapped to an eBOL value. <br /> Remove mappings in the Loaders
        on the Product, Terminal, or Counterparty Management screens.
      </Texto>
    </>
  )
}

export const EbolDrawerFooter = () => {
  const drawerType = useDrawerType()
  return (
    <>
      {drawerType === 'match' || drawerType === 'viewingAll' ? <InfoText /> : undefined}
      <CloseBtn />
      {drawerType === 'match' && <MatchBtn />}
      {drawerType === 'unmatch' && <UnmatchBtn />}
    </>
  )
}
